"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GameStatus = void 0;
var GameStatus = exports.GameStatus = /*#__PURE__*/function (GameStatus) {
  GameStatus[GameStatus["Initiating"] = 0] = "Initiating";
  GameStatus[GameStatus["Idle"] = 1] = "Idle";
  GameStatus[GameStatus["Running"] = 2] = "Running";
  GameStatus[GameStatus["FeaturePresentation"] = 3] = "FeaturePresentation";
  GameStatus[GameStatus["FeatureSelectPending"] = 4] = "FeatureSelectPending";
  GameStatus[GameStatus["WinPresentation"] = 5] = "WinPresentation";
  GameStatus[GameStatus["BigWinPresentation"] = 6] = "BigWinPresentation";
  GameStatus[GameStatus["GambleCollect"] = 7] = "GambleCollect";
  GameStatus[GameStatus["FailedToConnect"] = 8] = "FailedToConnect";
  GameStatus[GameStatus["Disconnected"] = 9] = "Disconnected";
  GameStatus[GameStatus["Reconnecting"] = 10] = "Reconnecting";
  GameStatus[GameStatus["Timeout"] = 11] = "Timeout";
  GameStatus[GameStatus["Error"] = 12] = "Error";
  GameStatus[GameStatus["InvalidToken"] = 13] = "InvalidToken";
  GameStatus[GameStatus["PlayerLocked"] = 14] = "PlayerLocked";
  GameStatus[GameStatus["ContactSupport"] = 15] = "ContactSupport";
  GameStatus[GameStatus["InvalidPlayerId"] = 16] = "InvalidPlayerId";
  GameStatus[GameStatus["APIDown"] = 17] = "APIDown";
  GameStatus[GameStatus["SpinError"] = 18] = "SpinError";
  GameStatus[GameStatus["Maintenance"] = 19] = "Maintenance";
  GameStatus[GameStatus["PlayerInput"] = 20] = "PlayerInput";
  GameStatus[GameStatus["GameInEarlyAccess"] = 21] = "GameInEarlyAccess";
  GameStatus[GameStatus["CountryBlocked"] = 22] = "CountryBlocked";
  GameStatus[GameStatus["ReplayRoundIdNotFound"] = 23] = "ReplayRoundIdNotFound";
  return GameStatus;
}({});
//# sourceMappingURL=GameStatus.js.map